export interface IFiatTransaction {
  amount: number;
  coin: string;
  creationTime: string;
  destAccount: {
    cbu: string;
  };
  status?: WITHDRAW_TRANSACTION_STATUS; // solo withdraw viene con status
  _id: string;
}

export interface IFiatDeposit {
  amount: string;
  bankId?: string;
  coin: string;
  creationTime: string;
  cuit?: string;
  status: number;
  updatedAt: string;
  userId?: string;
  user: string;
  _id: string;
}

export enum DEPOSIT_TRANSACTION_STATUS {
  // En teoria solo llega los assigned
  ASSIGNED = '0',
  NOT_ASSIGNED = '1',
  CANCELLED = '2',
}

export enum WITHDRAW_TRANSACTION_STATUS {
  PENDING = 0,
  EXECUTED = 1,
  FAILED = 2,
  CANCELLED = 3,
  PENDING_ADMIN = 4,
  RETRIED = 5,
}
